export const RMR_MIN_AGE = 13;
export const RMR_MIN_HEIGHT = 24;
export const RMR_MIN_WEIGHT = 10;
export const RMR_MIN_LEAN_BODY_MASS = 1;
export const RMR_MIN_PERCENT_BODY_FAT = 1;
export const MACRO_PROTOCOL_MIN_MACRO = 0;
//# sourceMappingURL=Utils.js.map